module.exports = __webpack_public_path__ + "media/application/images/ui/deal-how-to-phone-242bad52dd464e6e7c6b047723348f63.png";